import React, { useEffect, useState } from 'react';
import './LogoutModal.css';

const LogoutModal = ({ isOpen, onClose, onLogout }) => {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setIsClosing(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(onClose, 300); // Match this with animation duration
  };

  const handleLogout = () => {
    setIsClosing(true);
    setTimeout(onLogout, 300); // Match this with animation duration
  };

  return (
    <div className={`logout-modal-overlay ${isClosing ? 'closing' : ''}`}>
      <div className="logout-modal">
        <h2 className="logout-modal-title">Confirm Log-Out?</h2>
        
        <p className="logout-modal-message">Are you sure you want to log out?</p>
        
        <p className="logout-modal-description">
          Logging out will end your current session. Make sure to save any unsaved work before proceeding
        </p>

        <div className="logout-modal-buttons">
          <button className="cancel-button" onClick={handleClose}>
            Cancel
          </button>
          <button className="delete-button" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal; 